import { Expose } from 'class-transformer'

export class RecommendTagType {
  @Expose() id: number

  @Expose() name: string
}
